import React from "react";
import t from "babel-plugin-yate/macro";

const NoLocationPlaceholder = () => (
  <div className="flex items-center justify-center relative min-h-200 text-20">
    {t`You must choose a request location first.`}
  </div>
);

export default NoLocationPlaceholder;
